export default "__VITE_ASSET__DhM_TicA__"